<template>
  <v-list-item font-weight-black class="darkerheader">
    <v-list-item-icon class="uplifted mr-4 my-auto">
      <v-icon v-if="!showStatus || !jobItem" class="material-icons" color="primary" size="20" v-text="'$job'" />
      <v-tooltip v-else bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" size="20" class="material-icons" :color="statuscolor(jobItem.JobStatusId)"
            v-text="statusicon(jobItem.JobStatusId)" />
        </template>
        <span>{{ jobItem.JobStatus.Name }} {{ jobItem.JobSubStatus ? (' / ' + jobItem.JobSubStatus.Name) : '' }}</span>
      </v-tooltip>
    </v-list-item-icon>
    <v-list-item-content v-if="jobItem">
      <v-list-item-title class="d-flex">
        <div v-html="searchhighlight(jobItem.DisplayName, searchterm, true)"
          class="useThemeTextColor nowrapheader font-weight-bold" />
        <v-spacer />
        <div class="mr-2" style="color: #888888 !important; font-size: 0.9em !important;"
          v-text="jobItem.daysAgo + ' ' + $t('days_old')" />
      </v-list-item-title>
      <v-list-item-subtitle class="d-flex">
        <div v-html="searchhighlight(jobItem.JobType.Name, searchterm, true)" class="useThemeTextColor nowrapheader" />
        <v-spacer />
        <div class="mr-2" style="font-size: 0.9em !important;" :class="prioritycolor"
          v-html="searchhighlight(jobItem.JobPriority.Name, searchterm, true)" />
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="!noFLC" class="d-flex">
        <div class="nowrapheader" style="color: #888888 !important; font-size: 0.9em !important;"
          v-html="searchhighlight(jobItem.FirstLineComment, searchterm, true)" />
      </v-list-item-subtitle>
    </v-list-item-content>
    <double-click-hint v-if="!previewMode"></double-click-hint>
  </v-list-item>
</template>


<script>
import DoubleClickHint from "@/components/Buttons/DoubleClickHint.vue";

export default {
  name: "ParentJobContent",
  props: {
    jobItem: Object,
    previewMode: Boolean,
    showStatus: Boolean,
    noclick: Boolean,
    noFLC: Boolean,
  },
  components: {
    DoubleClickHint,
  },

  data() {
    return {
      checked: false,
      selectedItemId: null,
    };
  },

  mounted() {
    this.selectedItemId = parseInt(this.$route.params.jobId);
    
  },

  methods: {},

  computed: {
    remainingTime() {
      var result;
      if (this.jobItem.daysAgo) {
        result = this.jobItem.JobPriority.DueAfterHours - this.jobItem.daysAgo * 24;
      } else {
        result = this.jobItem.JobPriority.DueAfterHours - this.jobItem.hoursAgo;
      }
      return result;
    },

    prioritycolor() {
      var result;
      if (this.remainingTime < 0) {
        result = "error--text";
      } else if (this.remainingTime < /*this.jobItem.JobPriority.DueAfterHours / 2*/ 24) {
        result = "tertiary--text";
      } else {
        result = "";
      }
      
      return result;
    },

    searchterm() {
      return this.$store.state.filtersearchregex;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
</style>